import { alertIcon } from '../../images';

export default function AlertIcon(props: any) {
  return (
    <img className={props.className} src={alertIcon} alt="alert-icon" />
  );
}